import NProgress from 'nprogress'
export default NProgress.configure({ showSpinner: false, minimum: 0.1, speed: 150 })
